import axiosInstance from '../api/axios';
import type { GetRequisitesParams, PaginatedRequisitesResponse } from '@/types/requisite';

export const requisitesService = {
  getRequisites: async (params?: GetRequisitesParams): Promise<PaginatedRequisitesResponse> => {
    const response = await axiosInstance.get<PaginatedRequisitesResponse>('/requisites', { params });
    return response.data;
  },

  getRequisite: async (id: string) => {
    const response = await axiosInstance.get(`/requisites/${id}`);
    return response.data;
  },

  createRequisite: async (data: any) => {
    const response = await axiosInstance.post('/requisites', data);
    return response.data;
  },

  updateRequisite: async (id: string, data: any) => {
    const response = await axiosInstance.put(`/requisites/${id}`, data);
    return response.data;
  },

  deleteRequisite: async (id: string) => {
    const response = await axiosInstance.delete(`/requisites/${id}`);
    return response.data;
  },

  getRequisiteBlocks: async () => {
    const response = await axiosInstance.get('/requisites/blocks');
    return response.data;
  },

  createRequisiteBlock: async (data: any) => {
    const response = await axiosInstance.post('/requisites/blocks', data);
    return response.data;
  },

  updateRequisiteBlock: async (id: string, data: any) => {
    const response = await axiosInstance.put(`/requisites/blocks/${id}`, data);
    return response.data;
  },

  deleteRequisiteBlock: async (id: string) => {
    const response = await axiosInstance.delete(`/requisites/blocks/${id}`);
    return response.data;
  },

  toggleRequisiteActive: async (id: string) => {
    const response = await axiosInstance.patch(`/requisites/${id}/toggle-active`);
    return response.data;
  },

  unblockRequisite: async (id: string) => {
    const response = await axiosInstance.patch(`/requisites/${id}/unblock`);
    return response.data;
  },
};
